import React from 'react'
import { Redirect } from 'react-router-dom'
import LoginComponent from './Login'
import { isLogged } from '../../Utils/isLogged';
import { connect } from 'react-redux'
const Login = ({
  isLogged, ...props
}) => (
    isLogged
      ? <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      : <LoginComponent />
  )

export default connect(isLogged)(Login)